import type { theme } from 'styles/theme/hav-theme'

import * as S from './styles'

export type ButtonVariants =
  | 'primary'
  | 'secondary'
  | 'white'
  | 'success'
  | 'warning'
  | 'info'
  | 'danger'
  | 'transparent'
  | 'ghost'
  | 'icon'
  | 'border'
  | 'active'

export type SlimButtonProps = {
  id?: string
  type?: 'button' | 'submit' | 'reset'
  variant: ButtonVariants
  size?: keyof typeof theme.sizes.buttons
  /** @deprecated Use `size` prop instead height */
  height?: number
  content?: string
  disabled?: boolean
  loading?: boolean
  icon?: React.ReactNode // TODO: Remove React.ReactNode after all icons are migrated to (keyof typeof icons)
  iconColor?: string
  iconPosition?: 'left' | 'right'
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  'data-testid'?: string
}

export const SlimButton: React.FC<SlimButtonProps> = ({
  id,
  type,
  variant,
  size = 'md',
  height = size ? undefined : 36, // 36 = size.md
  content,
  disabled,
  loading,
  icon,
  iconColor,
  iconPosition = 'left',
  onClick,
  'data-testid': dataTestId,
}) => {
  const showContent = !!content && variant !== 'icon'

  return (
    <S.StyledButton
      data-testid={dataTestId}
      disabled={disabled}
      height={height}
      iconColor={iconColor}
      id={id}
      loading={loading}
      onClick={onClick}
      size={size}
      type={type}
      variant={variant}
    >
      {/* TODO: Render <Icon /> component with icon key and base icon size on button size */}
      {!!icon && iconPosition === 'left' && icon}
      {showContent && <S.ButtonText size={size || 'md'}>{content}</S.ButtonText>}
      {!!icon && iconPosition === 'right' && icon}
    </S.StyledButton>
  )
}
